import { Grid, Stack, Title } from '@mantine/core';
import APPLICATION_LIST from 'constant/applicationList';
import ApplicationItem from 'modules/pages/entrypoint/ApplicationItem';
import React from 'react';

const EntryPoint = () => {
  return (
    <Stack>
      <Title order={2}>Applications</Title>
      <Grid gutter={24} grow>
        {APPLICATION_LIST.map((item, index) => (
          <Grid.Col span={{ base: 12, md: 6 }} key={index}>
            <ApplicationItem
              key={index}
              title={item.title}
              description={item.description}
              url={item.url}
            />
          </Grid.Col>
        ))}
      </Grid>
    </Stack>
  );
};

export default EntryPoint;
